import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ForumState {
  forum: Record<any, any>;
}

const initialState: ForumState = {
  forum: {},
};

export const forumSlice = createSlice({
  name: "forum",
  initialState,
  reducers: {
    setForum: (state, action: PayloadAction<Record<string, any>>) => {
      state.forum = action.payload;
    },
  },
});

export const { setForum } = forumSlice.actions;
export default forumSlice.reducer;
